import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { deepEqual } from './../../utils';

import './styles.css';

const INITIAL_STATE = {
  isEditing: false,
};

class VehicleCurrentFocusCell extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !deepEqual(this.props, nextProps)
      || !deepEqual(this.state, nextState);
  }

  render() {
    const { currentFocus: focus } = this.props;
    return (this.state.isEditing
      ? (
        <div className="current-focus-wrapper editing">
          <div className="primary">
            <small>Editando Foco {focus.id}</small>
          </div>
        </div>
      ) : (
        <div className="current-focus-wrapper">
          <div className="sequence-icon-wrapper">
            <i className="md-icon">navigate_next</i>
          </div>

          <div className="status-wrapper">
            <div className="status upcoming">
              <i className="md-icon">check</i>
            </div>
          </div>

          <div className="focus-wrapper">
            <div className="title">
              <i className="md-icon">file_upload</i>
              {'  '}
              {'NOVA ERA'}
            </div>
            <div className="actions">
              <a
                className="button"
                role="button"
                tabIndex="0"
              >
                <i className="md-icon">navigate_before</i>
              </a>
              <a
                className="button"
                role="button"
                tabIndex="0"
              >
                <i className="md-icon">content_copy</i>
              </a>
              <a
                className="button"
                role="button"
                tabIndex="0"
              >
                <i className="md-icon">warning</i>
              </a>
              <a
                className="button"
                role="button"
                tabIndex="0"
              >
                <i className="md-icon">message</i>
              </a>
              <a
                className="button"
                role="button"
                tabIndex="0"
              >
                <i className="md-icon">cancel</i>
              </a>
            </div>
          </div>
        </div>
      ));
  }
}

VehicleCurrentFocusCell.propTypes = {
  currentFocus: PropTypes.object,
};

VehicleCurrentFocusCell.defaultProps = {
  currentFocus: null,
};

export default VehicleCurrentFocusCell;



// WEBPACK FOOTER //
// ./src/VehicleFocus/CurrentFocusCell/index.js